import GridContainer from "components/UI/Grid/GridContainer.js";
import { ArrowForwardIos, Search } from "@material-ui/icons";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import FieldglassButton from "components/UI/FieldglassButton";
import GridItemTS from "components/UI/Grid/GridItemTS";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useConsolidatedWorkers } from "services/input-core/consolidated-workers/get-all-consolidated-workers";
import { TitlePages } from "components/UI/TitlePage/TitlePages";
import { useConsolidatedWorkerContext } from "store/consolidatedWorker";

export default function ConsolidatedWorker() {
  const navigate = useNavigate();
  const { t } = useTranslation("consolidated-worker");
  const { getConsolidatedWorkers } = useConsolidatedWorkerContext();

  const { data, isLoading, isError } = useConsolidatedWorkers({
    onSuccess: (data: any) => {
      getConsolidatedWorkers(data);
    },
  });

  const content = () => {
    if (isError) {
      return [
        <td colSpan={4}>
          Something went wrong when trying to get the consolidated workers.
        </td>,
      ];
    }

    if (isLoading) {
      return <Skeleton />;
    }

    if (data?.length === 0) {
      return <div>No data</div>;
    }

    return (
      <ReactTable
        columns={[
          {
            Header: t("fullName"),
            accessor: "fullName",
          },
          // {
          //   Header: t("consolidatedWorkerId"),
          //   accessor: "consolidatedWorkerId",
          // },
          {
            Header: t("securityID"),
            accessor: "securityID",
          },
          {
            Header: t("consolidatedWorkerFieldglassID"),
            accessor: "consolidatedWorkerFieldglassID",
          },
          {
            Header: t("Supplier"),
            accessor: "supplier",
          },
          {
            Header: t("actions"),
            accessor: "actions",
          },
        ]}
        data={
          data?.map((consolidatedWorker) => ({
            consolidatedWorkerId: consolidatedWorker.consolidatedWorkerID,
            consolidatedWorkerFieldglassID:
              consolidatedWorker.consolidatedWorkerFieldglassID,
            securityID: consolidatedWorker.securityID,
            fullName: consolidatedWorker.fullName,
            supplier: `${consolidatedWorker.vendorNumber} - ${consolidatedWorker.vendorName}`,
            actions: (
              <div className="actions-right">
                <ButtonTS
                  justIcon
                  color="primary"
                  round
                  size="sm"
                  aria-label="Access worker"
                  onClick={() =>
                    navigate(
                      `/app/consolidatedworkers/profile?id=${consolidatedWorker.consolidatedWorkerID}`
                    )
                  }
                >
                  <ArrowForwardIos />
                </ButtonTS>
              </div>
            ),
          })) || []
        }
      />
    );
  };

  return (
    <GridContainer>
      <GridItemTS xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Search />
            </CardIcon>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <TitlePages type="sidebar" title="consolidated-workers" />
              <FieldglassButton type="sow" />
            </div>
          </CardHeader>
          <CardBody>{content()}</CardBody>
        </Card>
      </GridItemTS>
    </GridContainer>
  );
}
